export default {"src":"/_next/static/media/Close.658c08f8.svg","height":43,"width":43,"blurWidth":0,"blurHeight":0};